
export class Note {
    constructor({
                    id= null,
                    note= '',
                    noteable_id= null,
                    noteable_type= "",
                    created_at= new Date(),
                    updated_at= new Date(),
                    deleted_at= null,
                } = {}) {

        this.id=id;
        this.note=note;
        this.noteable_id=noteable_id;
        this.noteable_type=noteable_type;
        this.created_at=created_at;
        this.updated_at=updated_at;
        this.deleted_at=deleted_at;

    }

    setDeal(dealId){
        this.noteable_id = dealId;
        this.noteable_type = "App\\Models\\Deal";
    }

}

export function createNote(data={}) {
    return Object.freeze(new Note(data));
}